export default function titleFontSize(fontSize){
  return `clamp(1rem, 15cqw, ${fontSize || 16}px)`
}